import React, {useEffect, useState} from 'react';
import View from "./components/unfox-design/View";
import Profile from "./components/panels/Profile";
import Theme from "./components/unfox-design/Theme";
import {motion} from "framer-motion";
import Loader from "./components/unfox-design/Loader";
import Modal from "./components/unfox-design/Modal";
import ModalCard from "./components/unfox-design/ModalCard";
import Configuration from "./components/panels/Configuration";
import Friends from "./components/panels/Friends";
import Auth from "./components/panels/Auth";
import Register from "./components/panels/Register";
import {ACCENT, NAV_BUTTONS, SCHEME} from "./config";
import Button from "./components/unfox-design/Button";
import {Icon28Settings, Icon28User, Icon28UserAddBadgeOutline} from "@vkontakte/icons";
import ConfigurationBadlion from "./components/panels/ConfigurationBadlion";
import ConfigurationProstoCraft from "./components/panels/ConfigurationProstoCraft";
import API from "./API";

function App() {


    let [activePanel, setPanel] = useState('profile');
    let [scheme, setScheme] = useState("light");
    let [alert, setAlert] = useState(false);
    let [nav, setNav] = useState(false);
    let [hwid, setHwid] = useState('');

    useEffect(() => {
        setAccent(ACCENT);
        toggleNav(true);
        if (!localStorage.accessToken && activePanel !== 'register') {
            go('auth');
        }
    }, [activePanel]);

    const go = (e) => {
        setPanel(e);
    }


    let updateHwid = (hwid) => {
        setHwid(hwid);
    }

    let showAlert = (title, actions) => {
        setAlert(
            <motion.div key="alert" transition={{duration: 0.2}} initial={{opacity: 0, scale: 1.2}}
                        animate={{scale: [1.1, 1], opacity: 1}} exit={{opacity: 0}} className="Alert--wrapper">
                <div className="Alert--bg" onClick={() => {
                    setAlert(false)
                }}/>
                <motion.div className="Alert">
                    <div className="Alert--placeholder">
                        {title}
                    </div>
                    <div className="Alert--actions">
                        {actions}
                    </div>
                </motion.div>
            </motion.div>
        )
        if (!title) {
            setAlert(false);
        }
    }

    let showLoader = (e) => {
        {
            e ? setAlert(
                <div className="Alert--wrapper">
                    <div className="Alert--bg"/>
                    <Loader/>
                </div>
            ) : setAlert(false)
        }
    }

    let showLoaderFull = (e) => {
        {
            e ? setAlert(
                <div className="Alert--wrapper">
                    <div className="Alert--bg--f"/>
                    <Loader/>
                </div>
            ) : setAlert(false)
        }
    }

    let showModal = (e, title, content) => {
        {
            e ? setAlert(
                <div className="Alert--wrapper">
                    <div className="Alert--bg" onClick={() => {
                        setAlert(false)
                    }}/>
                    <Modal title={title} callback={() => {
                        setAlert(false)
                    }}>
                        {content}
                    </Modal>
                </div>
            ) : setAlert(false)
        }
    }

    let showModalCard = (e, icon, title, content, actionName) => {
        {
            e ? setAlert(
                <div className="Alert--wrapper">
                    <div className="Alert--bg" onClick={() => {
                        setAlert(false)
                    }}/>
                    <ModalCard actionName={actionName} icon={icon} title={title} callback={() => {
                        setAlert(false)
                    }}>
                        {content}
                    </ModalCard>
                </div>
            ) : setAlert(false)
        }
    }

    let toggleNav = (e) => {
        if (e === true) {
            let val = [
                {
                    type: "content",
                    items: [
                        NAV_BUTTONS.map((item, key) => {
                            return (<Button onClick={() => {
                                if(item.title === "Download"){
                                    API.execute("downloadLoader", {accessToken: localStorage.accessToken}).then(response =>{
                                        const link = document.createElement('a');
                                        link.href = "https://zware.space/loaderBuilds/" + response.response;
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                    });
                                }
                                else {
                                    window.open(item.link)
                                }
                            }}
                                            style={key === 0 ? {marginRight: 8} : {}}>{item.title}</Button>)
                        })
                    ]
                },
                {
                    name: "Profile",
                    icon: <Icon28User/>,
                    action: () => {
                        go('profile');
                    },
                    selected: activePanel === 'profile',
                },
                {
                    name: "Configuration",
                    icon: <Icon28Settings/>,
                    action: () => {
                        go('config');
                    },
                    selected: activePanel === 'config',
                },
                {
                    name: "Configuration ProstoCraft",
                    icon: <Icon28Settings/>,
                    action: () => {
                        go('configpc');
                    },
                    selected: activePanel === 'configpc',
                },
                {
                    name: "Configuration Badlion",
                    icon: <Icon28Settings/>,
                    action: () => {
                        go('configbadlion');
                    },
                    selected: activePanel === 'configbadlion',
                },
                {

                    name: "Friends",
                    icon: <Icon28UserAddBadgeOutline/>,
                    action: () => {
                        go('friends');
                    },
                    selected: activePanel === 'friends',
                }
            ]
            setNav(val)
        } else {
            setNav(false)
        }
    }

    let setAccent = (color) => {
        document.getElementById("root").style.setProperty("--accent", color);
    }

    return (
        <Theme scheme={SCHEME}>
            <View
                alert={alert}
                activePanel={activePanel}
                navs={nav}
            >
                <Profile id="profile"
                         showLoaderFull={showLoaderFull}
                         showModal={showModal}
                         updateHwid={updateHwid}
                         go={go}
                         setScheme={() => {
                             setScheme('light')
                         }}/>
                <Configuration id="config"
                               showLoaderFull={showLoaderFull}
                               updateHwid={updateHwid}
                               hwid={hwid}
                />
                <ConfigurationProstoCraft id="configpc"
                               showLoaderFull={showLoaderFull}
                               updateHwid={updateHwid}
                               hwid={hwid}
                />
                <ConfigurationBadlion id="configbadlion"
                               showLoaderFull={showLoaderFull}
                               updateHwid={updateHwid}
                               hwid={hwid}
                />
                <Friends id="friends"
                         showLoaderFull={showLoaderFull}
                />

                <Auth id="auth"
                      go={go}
                      toggleNav={toggleNav}
                />
                <Register id="register"
                          go={go}
                          toggleNav={toggleNav}
                />

            </View>
        </Theme>

    );
}

export default App;
